var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "no-logo" },
    [
      _c("img", {
        staticClass: "no-logo__default-logo",
        attrs: { src: "/ressources/logged/img/common/defaultNoLogo.png" }
      }),
      _vm._v(" "),
      _c("CompassButton", {
        staticClass: "no-logo__button",
        attrs: { label: _vm.$t.__("appearance.noLogo.add_logo_button") },
        on: {
          click: function($event) {
            _vm.displayConfirmModal = true
          }
        }
      }),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          staticClass: "no-logo__modal",
          attrs: {
            visible: _vm.displayConfirmModal,
            title: _vm.$t.__("appearance.noLogo.confirm_modal_title"),
            size: "small"
          },
          on: {
            "update:visible": function($event) {
              _vm.displayConfirmModal = $event
            },
            closed: function($event) {
              _vm.displayConfirmModal = false
            }
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c(
              "p",
              {
                staticClass:
                  "no-logo__modal-description typographies-paragraph-medium-regular"
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t.__("appearance.noLogo.confirm_modal_description")
                    ) +
                    "\n            "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "no-logo__modal-footer" },
              [
                _c("CompassButton", {
                  staticClass: "no-logo__modal-button",
                  attrs: {
                    type: "secondary",
                    label: _vm.$t.__("common.actions.cancel")
                  },
                  on: {
                    click: function($event) {
                      _vm.displayConfirmModal = false
                    }
                  }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "no-logo__modal-button",
                  attrs: {
                    type: "primary-destructive",
                    label: _vm.$t.__(
                      "appearance.noLogo.confirm_modal_continue_button"
                    )
                  },
                  on: {
                    click: function($event) {
                      return _vm.goToUrl("/?_f=companyPreferences&action=logo")
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }